module.exports = __webpack_public_path__ + "media/images/evaluacion-df303aba363ea5fa4016e68af2a09772.png";